import Vue from 'vue'
import router from "@/router";
import store from "./store";

const ID_TOKEN_KEY = "auth_token";

export const getToken = () => {
    return Vue.$jwt.getToken();
};

export const getRoles = () => {
    if(Vue.$jwt.hasToken()){
        const user = Vue.$jwt.decode();
        store.dispatch('setUserName', user.unique_name)
        return user.role;
    }
}
export const isRouled = (route) => {
    if(Vue.$jwt.hasToken()){
        const user = Vue.$jwt.decode();
        const userRoles = user.role;
        if(Date.now() < user.exp * 1000) {
            if(typeof userRoles == "string"){
                return route.meta.roles.indexOf(userRoles) != -1;
            } else {
                return !!userRoles.filter(role => {
                    return route.meta.roles.indexOf(role) != -1;
                }).length
            }
        } else {
            router.push('/log-in');
        }
    } else {
        router.push('/log-in');
    }
}
export const saveToken = token => {
    localStorage.setItem(ID_TOKEN_KEY, token);
};
export const destroyToken = () => {
    localStorage.removeItem(ID_TOKEN_KEY);
};

export default { getToken, isRouled, getRoles, saveToken, destroyToken };
